/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e984777ce22287f29cdd0cbd409ad3ca986301ef";
